import { Component} from '@angular/core';

@Component({
  selector: 'prof-topnav-plain',
  templateUrl: './topnav-plain.component.html',
  styleUrls: ['./topnav-plain.component.scss'],
  standalone: false
})
export class TopnavPlainComponent {
  constructor() {}
}
